import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ tournamentName = null, tournamentId = null, currentSection = null }) => {
  const location = useLocation();

  const shouldShowBreadcrumb = () => {
    const tournamentPaths = ['/tournament-details', '/match-predictions'];
    return tournamentPaths?.some(path => location?.pathname?.includes(path)) && tournamentName;
  };

  if (!shouldShowBreadcrumb()) {
    return null;
  }

  const getBreadcrumbItems = () => {
    const items = [];

    if (location?.pathname?.includes('/tournament-details')) {
      items?.push(
        { label: 'Tournaments', path: '/user-dashboard', isLink: true },
        { label: tournamentName, path: null, isLink: false }
      );
    } else if (location?.pathname?.includes('/match-predictions')) {
      items?.push(
        { label: 'Tournaments', path: '/user-dashboard', isLink: true },
        { label: tournamentName, path: tournamentId ? `/tournament-details/${tournamentId}` : '/tournament-details', isLink: true },
        { label: currentSection || 'Predictions', path: null, isLink: false }
      );
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <div className="breadcrumb-container">
      <div className="breadcrumb-content">
        {breadcrumbItems?.map((item, index) => (
          <div key={index} className="breadcrumb-item">
            {item?.isLink ? (
              <>
                <Link to={item?.path} className="breadcrumb-link">
                  {item?.label}
                </Link>
                {index < breadcrumbItems?.length - 1 && (
                  <Icon name="ChevronRight" size={16} className="breadcrumb-separator" />
                )}
              </>
            ) : (
              <span className="breadcrumb-current">{item?.label}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;